import React from 'react'

interface TextFilterProps {
  inputId: string
  label: string
  value: string
  placeholder?: string
  onChange: (value: string) => void
}

const TextFilter: React.FC<TextFilterProps> = ({ inputId, label, value, placeholder, onChange }) => (
  <div>
    <label className="form-label" htmlFor={inputId}>{label}</label>
    <input
      id={inputId}
      type="text"
      className="form-control"
      autoComplete="off"
      value={value}
      placeholder={placeholder}
      onChange={event => onChange(event.target.value)}
    />
  </div>
)

export default TextFilter
